<template>
  <v-container>
    <v-card-text class="signup-text_in_Con">
      <div class="txtst_info_gray">
        회원으로 가입하시려면 아래 서비스 이용약관 및 개인정보 처리방침을 반드시
        읽고 “동의” 버튼을 선택해 주세요.
      </div>
      <div class="mt-4">
        <div class="dot_tt16 mb-2">이용약관</div>
        <div class="signU_rule_box">
          <div class="agreePage ruleboxst">
            <v-row no-gutters>
              <!--시행중인 이용약관 보기-->
              <v-col cols="12" class="agreePage">
                <h3 class="agree_h1">제 1 장 총칙</h3>
                <ul class="agree_list">
                  <li>
                    <h4 class="agree_h2">제 1 조 (약관의 목적)</h4>
                    <p class="agree_p">
                      이 약관은 주식회사 ㈜비즈니스온커뮤니케이션(이하 "회사"라
                      한다)이 제공하는 글로싸인엔터프라이즈 서비스(이하
                      "서비스"라 한다)를 이용함에 있어서 회사와
                      서비스이용자(이하 "회원"이라 한다)간에 서비스 이용의 방법
                      및 기타 필요한 사항을 규정함을 목적으로 합니다.
                    </p>
                  </li>
                  <li>
                    <h4 class="agree_h2">제 2 조 (약관의 효력 및 변경)</h4>
                    <ul class="agree_in">
                      <li>
                        ① 이 약관은 회사의 서비스 사이트(sign.smartbill.co.kr)에
                        게시하여 공지하거나 전자우편, 기타의 방법으로 회원에게
                        통지함으로써 효력을 발생합니다.
                      </li>
                      <li>
                        ② 회사는 제공하게 되는 새로운 서비스의 적용, 보안체계의
                        향상 및 유지, 정부에 의한 시정명령의 이행 등 기타 회사의
                        업무상 약관을 변경하여야 할 중요한 사유가 있다고 판단될
                        경우 약관을 변경할 수 있으며, 변경된 약관은 제1항과 같은
                        방법으로 공지 또는 통지함으로써 효력을 발생합니다.
                      </li>
                      <li>
                        ③ 변경된 약관의 공시된 날로부터 1개월 이내에 회원이
                        회사에 서면으로 이의를 제기하지 아니한 때에는 변경된
                        약관을 승인한 것으로 간주하며, 이의를 제기하는 경우
                        회사는 회원과 협의를 거친 후 수용여부를 결정합니다.
                      </li>
                      <li>
                        ④ 약관의 내용은 회사의 서비스 사이트에 항상 게시됩니다.
                      </li>
                    </ul>
                  </li>
                  <li>
                    <h4 class="agree_h2">
                      제 3 조 (명시되지 않은 약관의 적용)
                    </h4>
                    <p class="agree_p">
                      이 약관에 명시되지 아니한 사항은 관계법령 및 기타관습에
                      따릅니다.
                    </p>
                  </li>
                  <li>
                    <h4 class="agree_h2">제 4 조 (용어의 정의)</h4>
                    <ul class="agree_in">
                      <li>
                        ① 글로싸인엔터프라이즈: 블록체인 기반의 전자계약
                        서비스를 말합니다.
                      </li>
                      <li>
                        ② 전자계약 : 오프라인에서 주고받던 계약서를 인터넷상에서
                        온라인으로 주고받는 계약서를 말합니다.
                      </li>
                      <li>
                        ③ 회원 : 회사와 이용계약을 체결한 이용자로서 처음 가입한
                        자는 관리자로 설정됩니다.<br />
                        <ul class="agree_in02">
                          <li>
                            - 관리자 : 기업을 대표하여 최초로 가입하는 회원이며
                            회사의 모든 권한과 책임을 부여 받습니다.
                          </li>
                        </ul>
                      </li>
                      <li>
                        ④ 아이디(ID) : 회원식별과 서비스 이용을 위하여 회원이
                        선정하고 회사가 승인한 문자와 숫자의 조합입니다.
                      </li>
                      <li>
                        ⑤ 비밀번호(PW) : ID에 대하여 사용자임을 확인하고 회원
                        자신의 비밀 보호를 위하여 회원이 선정하고 회사가 승인한
                        문자와 숫자의 조합입니다.
                      </li>
                      <li>
                        ⑥ 블록체인 계정주소 : 블록체인 네트워크 상에서 이용자
                        식별을 위한 문자열로, 블록체인 네트워크 상에서 생성되어
                        제공됩니다.
                      </li>
                      <li>
                        ⑦ 블록체인 계정주소의 비밀번호 (이하 블록체인 비밀번호)
                        : 블록체인 계정주소의 사용자임을 확인하고 회원 자신의
                        비밀 보호를 위하여 회원이 선정하고 회사가 승인한 문자와
                        숫자의 조합입니다.
                      </li>
                    </ul>
                  </li>
                </ul>
                <h3 class="agree_h1">제 2 장 서비스 이용 신청</h3>
                <ul class="agree_list">
                  <li>
                    <h4 class="agree_h2">제 5 조 (이용 신청)</h4>
                    <ul class="agree_in">
                      <li>
                        ① 본 서비스 이용 희망 개인은 서비스 사이트에 접속하여
                        회원으로 가입함으로써 회사와 서비스 이용계약이
                        성립됩니다.
                      </li>
                      <li>
                        ② 회원가입은 이용 희망 개인이 서비스의 이용약관에 동의한
                        후, 온라인 회원가입 신청서에 개인의 정보를 기재하여
                        신청하고, 이에 대하여 회사가 승인함으로써 성립합니다.
                      </li>
                      <li>
                        ③ 본 서비스 이용 희망 기업은 기업의 대표 관리자가 본
                        서비스를 통하여 회사와 서비스 신청 계약을 체결함으로써
                        이용계약이 성립됩니다.
                      </li>
                      <li>
                        ④ 서비스 신청 계약 시 사업자등록증 사본과 법인인감증명서
                        원본이 첨부되어야 합니다.
                      </li>
                      <li>
                        ⑤ 회원가입 신청서 및 서비스 신청 계약서에 입력한 이용
                        개인의 정보는 모두 실제 데이터로 간주되며, 허위정보임이
                        판명되면 서비스의 제한을 받을 수 있습니다.
                      </li>
                    </ul>
                  </li>
                </ul>
                <h3 class="agree_h1">제 3 장 서비스의 제공 및 이용</h3>
                <ul class="agree_list">
                  <li>
                    <h4 class="agree_h2">제 6 조 (서비스의 제공)</h4>
                    <ul class="agree_in">
                      <li>
                        ① 회사가 회원에게 제공하는 서비스 내용은 다음 각 호와
                        같습니다.
                        <ul class="agree_in02">
                          <li>- 전자계약의 작성 및 계약요청 서비스</li>
                          <li>- 전자계약의 조회 및 승인 서비스</li>
                          <li>- 전자계약의 이력 조회 서비스</li>
                          <li>
                            - 블록체인 전자서명을 통한 전자문서 서명 서비스
                          </li>
                          <li>
                            - 블록체인 인증을 통한 전자문서의 진본 확인 서비스
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <h4 class="agree_h2">제 7 조 (서비스의 이용)</h4>
                    <ul class="agree_in">
                      <li>
                        ① 서비스는 제5조에 의거하여 가입을 완료한 시점부터 즉시
                        이용할 수 있습니다. 이용요금에 대한 결제가 정상적으로
                        이루어진 회원에 한하여 이용이 가능합니다.
                      </li>
                      <li>
                        ② 서비스의 이용시간은 연중무휴 1일 24시간을 원칙으로
                        하며, 다만 다음 각 호에 해당하는 경우는 예외로 합니다.
                        <ul class="agree_in02">
                          <li>
                            - 정기점검, 서비스 이용향상 등을 위해 회사가 정한
                            날이나 시간
                          </li>
                          <li>
                            - 시스템 장애, 서비스 이용의 폭주, 천재지변으로 인한
                            서비스의 중단
                          </li>
                          <li>- 위의 각 호에 준하는 경우</li>
                        </ul>
                      </li>
                      <li>
                        ③ 회사는 이용시간을 제한하는 경우 그 내용을 사전에
                        사이트를 통해 공지하여야 합니다.
                      </li>
                    </ul>
                  </li>
                  <li>
                    <h4 class="agree_h2">
                      제 8 조 (블록체인 계정주소과 비밀번호의 관리)
                    </h4>
                    <ul class="agree_in">
                      <li>
                        ① 회원 개인과 기업의 고유한 블록체인 계정주소는
                        시스템(블록체인 네트워크)에서 자동 생성 되며, 회원가입과
                        기업등록(생성)을 통해 발급됩니다.
                      </li>
                      <li>
                        ② 블록체인 계정주소는 최초 생성 후에 변경할 수 없습니다.
                      </li>
                      <li>
                        ③ 블록체인 비밀번호는 블록체인 계정주소 최초 생성시
                        회원이 직접 설정하며, 변경 할 수 있습니다. 다만, 이에
                        대한 관리는 전적으로 회원이 책임지고 관리해야 합니다.
                      </li>
                      <li>
                        ④ 블록체인 비밀번호는 시스템에서 확인하거나,
                        시스템관리자가 재설정 할 수 없으며, 비밀번호 분실 시
                        전자계약을 생성하거나, 승인할 수 없습니다.
                      </li>
                    </ul>
                  </li>
                  <li>
                    <h4 class="agree_h2">
                      제 9 조 (전자문서/전자서명 법적 효력)
                    </h4>
                    <ul class="agree_in">
                      <li>
                        ① 전자문서 및 전자거래 기본법 제4조 제1항에 의해 전자적
                        형태로 되어 있다는 이유로 문서로서의 효력이 부인되지
                        않지만 다른 법령에 특별한 규정이 있는 경우 법적 효력이
                        인정되지 않을 수 있으며 이와 관련되어 발생하는 문제에
                        대해서 책임지지 않습니다.
                      </li>
                      <li>
                        ② 전자서명에 사용되는 서명은 전자서명법 제3조 제3항에
                        의해 당사자간의 약정에 따른 서명, 서명날인 또는 기명
                        날인으로서의 효력을 가지지만 다른 법령에 특별한 규정이
                        있는 경우 법적 효력이 인정되지 않을 수 있으며 이와
                        관련되어 발생하는 문제에 대해서 책임지지 않습니다.
                      </li>
                    </ul>
                  </li>
                </ul>
                <h3 class="agree_h1">제 4 장 회원정보의 관리</h3>
                <ul class="agree_list">
                  <li>
                    <h4 class="agree_h2">
                      제 10 조 (회원정보의 수집 및 이용목적)
                    </h4>
                    <ul class="agree_in">
                      <li>
                        ① 회원으로 가입하여 서비스를 이용하고자 하는 이용자는
                        회사에서 요청하는 제반 정보(회사명, 대표자명,
                        사업자등록번호, 이용자ID, 비밀번호, 이름, 연락처 등)를
                        제공하여야 합니다. 또한 지능형 집계 정보 제공 서비스를
                        위해 6조 1항의 서비스 사용시 발생하는 세부 내역 데이터
                        등 기타 정보를 상황에 따라 수집할 수 있습니다.
                      </li>
                      <li>
                        ② 모든 회원은 반드시 회원 본인의 정보를 제공하여야만
                        서비스를 이용할 수 있으며, 타인의 정보를 도용하거나
                        허위의 정보를 등록하는 등 본인의 진정한 정보를 등록하지
                        않은 회원은 서비스 이용과 관련하여 아무런 권리를 주장할
                        수 없으며, 관계 법령에 따라 처벌 받을 수 있습니다.
                      </li>
                      <li>
                        ③ 회원가입은 반드시 본인의 진정한 정보를 통하여만 가입할
                        수 있으며 회사는 회원이 등록한 정보에 대하여 확인조치를
                        할 수 있습니다. 회원은 회사의 확인조치에 대하여 적극
                        협력하여야 하며, 만일 이를 준수하지 아니할 경우 회사는
                        회원이 등록한 정보가 부정한 것으로 처리할 수 있습니다.
                      </li>
                    </ul>
                  </li>
                  <li>
                    <h4 class="agree_h2">제 11 조 (회원정보의 보호)</h4>
                    <ul class="agree_in">
                      <li>
                        ① 당사는 수집된 회원정보가 분실, 도난 , 누출 , 변조 또는
                        훼손되지 아니하도록 보안 및 안정성 확보에 필요한 기술적
                        조치 등을 취하여야 합니다.
                      </li>
                      <li>
                        ② 당사는 서비스와 관련하여 취득한 회원의 개인정보를
                        본인의 사전 승낙 없이 타인에게 누설, 공개 또는 배포할 수
                        없으며, 서비스 관련 업무 이외의 상업적 목적으로 사용할
                        수 없습니다. <br />
                        다만, 다음 각 호의 해당하는 경우에는 그러하지 아니합니다
                        <ul class="agree_in02">
                          <li>
                            1. 관계법령에 의하여 수사상의 목적으로
                            관계기관으로부터 요구 받은 경우.
                          </li>
                          <li>2. 정보통신윤리위원회의 요청이 있는 경우.</li>
                          <li>
                            3. 서비스 제공에 따른 요금정산을 위하여 필요한 경우.
                          </li>
                          <li>
                            4. 통계작성, 학술연구 또는 시장조사를 위하여 필요한
                            경우로서 특정 개인을 식별할 수 없는 형태로 제공하는
                            경우.
                          </li>
                          <li>
                            5. 본 서비스에 기업정보 및 개인신용평가를 제공하는
                            신용정보사업자의 요청이 있는 경우.
                          </li>
                          <li>6. 기타 관계법령에 의한 경우.</li>
                        </ul>
                      </li>
                      <li>
                        ③ 제2항의 범위 내에서 당사는 광고업무와 관련하여 회원
                        전체 또는 일부의 개인정보에 관한 통계자료를 작성하여
                        이를 사용할 수 있고, 서비스를 통하여 회원의 컴퓨터에
                        쿠키를 전송할 수 있습니다. 이 경우 회원은 쿠키의 수신을
                        거부하거나 쿠키의 수신에 대하여 경고하도록 컴퓨터
                        브라우저의 설정을 변경할 수 있습니다.
                      </li>
                    </ul>
                  </li>
                  <li>
                    <h4 class="agree_h2">
                      제 12 조 (회원이용정보 및 자료의 보호)
                    </h4>
                    <ul class="agree_in">
                      <li>
                        ① 회사는 회원이 제공한 회원정보를 서비스 이용기간동안
                        보유하며, 회원 탈퇴시에는 회원정보를 관련법규에 따라
                        보존할 의무가 없는 한 즉시 폐기합니다.
                      </li>
                      <li>
                        ② 회원 가입 시 제공한 회원의 정보는(이름, 전자메일 주소,
                        연락처 등)글로싸인엔터프라이즈 모든 서비스의 원활한
                        운영을 위해, 경우에 따라 공유될 수 있습니다. (단,
                        비밀번호는 절대 공유불가)
                      </li>
                    </ul>
                  </li>
                  <li>
                    <h4 class="agree_h2">
                      제 13 조 (각종 정보의 제공 및 광고성 정보수신 동의)
                    </h4>
                    <ul class="agree_in">
                      <li>
                        ① 회사는 회원에게 회사의 서비스 및 각종 행사 소개와
                        안내를 서신우편물, 전화, FAX, E-Mail, SMS, 기타 스마트폰
                        알림서비스 등을 통해 제공할 수 있습니다.
                      </li>
                      <li>
                        ② 회원은 회사 및 회사의 제휴업체가 정보통신망 이용촉진
                        및 정보보호에 관한 법률 제50조 제2항에 따라 회원의 전화,
                        FAX, E-Mail, SMS, 기타 스마트폰 알림서비스 등을 통하여
                        광고성 정보를 전송하는데 동의합니다.
                      </li>
                      <li>
                        ③회원의 개인정보는 관련 법률이 정하는 바에 따라 엄격히
                        관리되며, 회원은 원하지 않는 경우 회사가 제공하는 서비스
                        정보 또는 광고성 정보의 수신을 거부할 수 있습니다.
                      </li>
                    </ul>
                  </li>
                  <li>
                    <h4 class="agree_h2">제 14 조 (ID 부여 및 변경)</h4>
                    <ul class="agree_in">
                      <li>
                        ① ID는 다음 각 호에 해당하는 경우 회원 또는 회사의
                        요청에 의하여 변경할 수 있습니다.<br />
                        <ul class="agree_in02">
                          <li>- ID가 회원의 사생활 침해가 우려가 있는 경우</li>
                          <li>
                            - 타인에게 혐오감을 주거나 미풍양속에 어긋나는 경우
                          </li>
                          <li>- 기타 합리적인 사유가 있는 경우</li>
                        </ul>
                      </li>
                      <li>
                        ② ID 변경은 불가능하며 비밀번호는 수시로 변경할 수
                        있습니다. 다만, 이에 대한 관리는 전적으로 회원이
                        책임지고 관리해야 합니다.
                      </li>
                      <li>
                        ③ 회원은 ID와 비밀번호를 통하여 전자계약 조회만 가능하고
                        전자계약 요청 및 승인은 블록체인 인증을 통해 이용할 수
                        있습니다.
                      </li>
                    </ul>
                  </li>
                  <li>
                    <h4 class="agree_h2">제 15 조 (게시물의 관리)</h4>
                    <ul class="agree_in">
                      <li>
                        ① 회사는 회원이 게시하거나 등록한 내용이 다음 각 호에
                        해당한다고 판단되는 경우 회원에게 사전 통지나 동의없이
                        게시물을 삭제할 수 있으며, 게시물의 검열, 검색에 따른
                        어떠한 의무와 게시물의 내용 및 관리에 따른 일체의
                        손해배상책임을 부담하지 않습니다. <br />
                        <ul class="agree_in02">
                          <li>
                            - 다른 회원 또는 제3자를 비방하거나 중상모략으로
                            명예를 손상시키는 내용인 경우
                          </li>
                          <li>
                            - 공공 질서 및 미풍양속에 위반되는 내용인 경우
                          </li>
                          <li>
                            - 범죄적 행위와 결부된다고 판단되는 내용인 경우
                          </li>
                          <li>
                            - 제3자의 저작권 등 기타 권리를 침해하는 내용인 경우
                          </li>
                          <li>
                            - 광고성 글이나 음란물 등 사이트의 이용목적에
                            부합하지 않는 경우
                          </li>
                          <li>
                            - 기타 관계법령에 위배되거나 위배될 우려가 있는 경우
                          </li>
                        </ul>
                      </li>
                      <li>
                        ② 회원은 서비스를 이용하여 얻은 정보를 가공, 판매하는
                        행위 등 게재된 자료를 상업적으로 이용할 수 없으며 이를
                        위반하여 발생하는 제반문제의 책임은 회원에게 있습니다.
                      </li>
                    </ul>
                  </li>
                  <li>
                    <h4 class="agree_h2">
                      제 16 조 (쿠키(Cookie)의 운용 및 활용)
                    </h4>
                    <p class="agree_p">
                      회회사는 회원에게 적합하고 유용한 서비스를 제공하기 위해서
                      회원의 정보를 저장하고 수시로 불러오는 쿠키(cookie)를
                      사용합니다.<br />
                      또한 회사는 업무와 관련하여 회원전체 또는 일부의
                      개인정보에 관한 통계자료를 작성하여 이를 사용할 수 있으며,
                      서비스를 통하여 회원의 컴퓨터에 쿠키를 전송할 수
                      있습니다.<br />
                      이 경우 회원은 선택권을 가지고 있어 쿠키의 수신을
                      거부하거나 쿠키의 수신에 대하여 경고하도록 사용하는 컴퓨터
                      브라우저의 설정을 변경할 수 있습니다.<br />
                      단, 쿠키의 저장을 거부할 경우 로그인이 필요한 모든
                      서비스를 이용할 수 없게 됨으로써 발생되는 문제에 대한
                      책임은 회원에게 있습니다.
                    </p>
                  </li>
                  <li>
                    <h4 class="agree_h2">제 17 조 (링크)</h4>
                    <p class="agree_p">
                      회사는 회원에게 다른 회사의 웹사이트 또는 자료에 대한
                      링크를 제공할 수 있습니다.<br />
                      회사는 그러한 사이트 및 자료에 대한 아무런 통제권이
                      없으므로, 회원은 회사가 그와 같은 외부 사이트나 자료의
                      유용성에 대해 책임이 없으며, 그러한 사이트나 자료에 대한,
                      또는 그로부터 이용 가능한 내용, 광고, 제품이나 재료에 대해
                      회사가 아무런 보증도 하지 않고, 그에 대해 책임이 없음을
                      인정하고 이에 동의합니다.<br />
                      또한, 회원은 그러한 사이트나 자료에 대한, 또는 그를 통하여
                      이용 가능한 내용, 상품 또는 서비스를 이용하거나 이를
                      신뢰함으로 인해, 또는 이와 관련하여 야기되거나
                      야기되었다고 주장되는 어떠한 손해나 손실에 대하여 회사가
                      직접적 또는 간접적으로 책임을 지지 않음을 인정하고 이에
                      동의합니다.
                    </p>
                  </li>
                  <li>
                    <h4 class="agree_h2">제 18 조 (이용요금)</h4>
                    <ul class="agree_in">
                      <li>
                        ① 회사는 개인계약/기업계약 여부에 따라 서비스를 선불형
                        또는 후불형으로 제공합니다.
                      </li>
                      <li>
                        ② 개인계약 이용시 무통장 입금, 계좌이체, 신용카드,
                        휴대폰결제 등으로 선불 결제 할 수 있으며, 기업계약
                        이용시 자동이체 설정 후 후불 결제 됩니다.
                      </li>
                      <li>
                        ③ 이용요금은 회사에서 정한 요금정책에 따라 적용되며,
                        회사가 별도 계약을 체결하는 경우 계약서에 명시된 요금을
                        적용합니다.
                      </li>
                      <li>
                        ④ 회사는 별도 정한 경우를 제외하고는 회원 개인 또는
                        사업자등록번호 단위로 이용요금을 부과합니다.
                      </li>
                    </ul>
                  </li>
                  <li>
                    <h4 class="agree_h2">제 19 조 (청구 및 납입)</h4>
                    <ul class="agree_in">
                      <li>
                        ① 회사는 이용요금 납입청구서를 해당 청구월(1일~말일
                        거래분)의 익월 10일(영업일 기준)까지 인터넷을 통하여
                        회원에게 전송하고 회원은 사이트의 요금결제 메뉴를
                        이용하여 요금을 납부합니다.
                      </li>
                    </ul>
                  </li>
                  <li>
                    <h4 class="agree_h2">제 20 조 (이용요금 반환)</h4>
                    <ul class="agree_in">
                      <li>
                        ① 회사는 이용요금 등의 과납이 있을 경우 회원의
                        이의신청(청구일로부터 3월 이내에 한함)에 따라 다음 각
                        호에 해당하는 조치를 취합니다. <br />
                        <ul class="agree_in02">
                          <li>
                            - 과납 청구한 이용요금 등에 대하여는 그 금액을
                            감액하여 신청일 익월에 이용요금에서 상계하거나
                            탈퇴한 회원의 경우 해당금액을 반환 처리합니다.
                          </li>
                          <li>
                            - 이용요금 등을 반환 받아야 할 회원이 이용요금 등의
                            체납이 있는 경우 회사는 해당 금액에 대하여 공제하고
                            1호의 내용을 적용합니다.
                          </li>
                        </ul>
                      </li>
                      <li>
                        ② 회사는 과소청구액에 대하여는 익월에 합산하여
                        청구합니다.
                      </li>
                      <!-- 2018년 10월 18일 추가 -->
                      <li>
                        ③ 회원의 환불 요청이 있을 경우 회사는 아래와 같이 환불
                        조치를 합니다.
                        <div class="agree_in02">
                          <p class="pd-0">- 환불 기준</p>
                          <table class="term_tbl">
                            <colgroup>
                              <col style="width:40%" />
                              <col style="width:60%" />
                            </colgroup>
                            <tr>
                              <th class="ag_top">결제기간</th>
                              <th class="ag_top">환불금액</th>
                            </tr>
                            <tr>
                              <td>결제후 30일 이내</td>
                              <td class="ag_left">
                                결제후 30일 이내 결제금액의 10%차감 후 환불<br />
                                단, 잔액이 결제금액의 10%미만일 경우 환불 불가
                              </td>
                            </tr>
                            <tr>
                              <td>결제후 30일 이상 60일 이내</td>
                              <td class="ag_left">
                                결제금액의 20%차감 후 환불<br />
                                단, 잔액이 결제금액의 20%미만일 경우 환불 불가
                              </td>
                            </tr>
                            <tr>
                              <td>결제후 60일 이상 90일 이내</td>
                              <td class="ag_left">
                                결제금액의 30%차감 후 환불<br />
                                단, 잔액이 결제금액의 30%미만일 경우 환불 불가
                              </td>
                            </tr>
                            <tr>
                              <td>결제후 90일 이상 5년 이내</td>
                              <td class="ag_left">
                                환불 불가하며 잔액은 사용 가능
                              </td>
                            </tr>
                          </table>

                          <p class="mg_t5">
                            - 결제후 5년이 지나면 잔액이 소멸되어 사용이 불가함.
                          </p>
                        </div>
                      </li>
                      <!-- //2018년 10월 18일 추가 -->
                    </ul>
                  </li>
                </ul>
                <h3 class="agree_h1">제 5 장 책임</h3>
                <ul class="agree_list">
                  <li>
                    <h4 class="agree_h2">제 21 조 (회사의 의무)</h4>
                    <ul class="agree_in">
                      <li>
                        ① 회사는 제7조 2항에서 정한 경우를 제외하고 이 약관 및
                        관계법령이 정한 바에 따라 계속적, 안정적으로 서비스를
                        제공할 의무가 있습니다.
                      </li>
                      <li>
                        ② 회사는 서비스 관련 설비를 항상 운용가능한 상태로
                        유지보수하며, 장애가 발생하거나 멸실된 경우 지체없이
                        이를 수리/복구할 수 있도록 최선의 노력을 다하여야
                        합니다.
                      </li>
                      <li>
                        ③ 회사는 회원으로부터 제기되는 의견이나 불만이
                        정당하다고 인정할 경우 신속히 처리하여야 합니다. 다만,
                        신속히 처리가 곤란한 경우 회원에게 그 사유와 처리일정을
                        E-mail이나 서면 또는 전화로 통지하여야 합니다.
                      </li>
                      <li>
                        ④ 회사는 이용계약의 체결, 계약사항의 변경 및 해지 등
                        회원과의 계약관련 절차 및 내용 등에 있어 회원에게 편의를
                        제공하도록 노력해야 합니다.
                      </li>
                    </ul>
                  </li>
                  <li>
                    <h4 class="agree_h2">제 22 조 (회원의 의무)</h4>
                    <ul class="agree_in">
                      <li>
                        ① 회원은 이 약관 및 관계법령, 회사가 공지하는 사항을
                        준수하여야 하며, 기타 회사의 업무수행에 지장을 초래하는
                        행위를 할 수 없습니다.
                      </li>
                      <li>
                        ② 회원은 회사의 사전 승인 없이 서비스를 이용하여 어떠한
                        영리행위도 할 수 없습니다.
                      </li>
                      <li>
                        ③ 회원은 서비스를 이용하여 얻은 정보를 회사의 사전
                        승낙없이 복사, 복제, 개조, 번역하여 타인에게
                        제공하여서는 안됩니다.
                      </li>
                      <li>
                        ④ 회원은 자신의 ID와 비밀번호 / 블록체인 계정주소와
                        블록체인 비밀번호의 관리에 대하여 각별한 주의를 하여야
                        합니다.
                      </li>
                      <li>
                        ⑤ 회원은 자신의 ID가 부정하게 사용된 것을 발견한 즉시,
                        회사에 그 사실을 통보하여야 합니다.
                      </li>
                      <li>
                        ⑥ 회원은 서비스 이용과 관련하여 다음 각 호의 행위를 할
                        수 없습니다.<br />
                        <ul class="agree_in02">
                          <li>
                            - 다른 회원의 아이디(ID)를 부정 사용하는 행위.
                          </li>
                          <li>
                            - 범죄행위를 목적으로 이용하거나 기타 범죄행위와
                            관련된 행위.
                          </li>
                          <li>- 선량한 풍속 기타 사회질서에 반하는 행위.</li>
                          <li>- 타인의 명예를 훼손하거나 모욕하는 행위.</li>
                          <li>
                            - 타인의 지적재산권 등의 권리를 침해하는 행위.
                          </li>
                          <li>- 해킹 또는 컴퓨터바이러스를 유포하는 행위.</li>
                          <li>
                            - 광고 또는 광고성 정보를 전송 기타 영업을 위한
                            행위.
                          </li>
                          <li>
                            - 서비스의 안정적인 운영에 지장을 주거나 줄 우려가
                            있는 일체의 행위.
                          </li>
                          <li>- 기타 관계법령에 위배되는 행위.</li>
                          <li>
                            - 회원 중 회사관리자의 자격을 부여 받은 회원은
                            기업의 블록체인 계정주소/블록체인 비밀번호 등의
                            보안, 유출방지의무가 있으며 이를 통한 본 사이트를
                            이용하는 회사 내 소속 회원에 대한 관리 책임을
                            부담하며 이에 따른 그 어떠한 문제에 대해서도 당사는
                            책임을 지지 않습니다.
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <h4 class="agree_h2">제 23 조 (서비스 이용의 제한)</h4>
                    <ul class="agree_in">
                      <li>
                        ① 회사는 회원이 이 약관 위반 및 다음 각 호에 해당하는
                        경우 회사가 정한 소정의 기간내에 이를 해소하지 않으면
                        서비스 이용계약을 사전 통지나 동의없이 이용 제한 할 수
                        있습니다.<br />
                        <ul class="agree_in02">
                          <li>
                            - 제21조의 규정에 의한 회원의 의무를 이행하지 아니한
                            경우
                          </li>
                          <li>
                            - 회원이 서비스 이용요금을 납부기한 까지 납부하지
                            아니하는 경우
                          </li>
                          <li>
                            - 회원이 해산으로 인하여 법인 자격을 상실하게 되거나
                            부 존재 한다고 볼 수 있는 상당한 이유가 있을 경우
                          </li>
                          <li>
                            - 회원이 타인명의를 도용하여 신청 또는 신청서를
                            허위로 기재하는 등 부정한 방법으로 이용신청한 사실이
                            발견된 경우
                          </li>
                          <li>
                            - 다른 회원 또는 제3자의 지적재산권을 침해하는 경우
                          </li>
                          <li>
                            - 타인의 ID 또는 비밀번호를 부정하게 사용하는 경우
                          </li>
                          <li>
                            - 서비스를 이용하여 얻은 정보를 회사의 사전 승낙없이
                            복제 또는 유통시키거나 상업적으로 이용하는 경우
                          </li>
                          <li>
                            - 회원의 서비스 이용을 제한하거나 정지시킨 후 동일한
                            행위가 2회 이상 반복되는 경우
                          </li>
                          <li>
                            - 사회통념상의 풍속, 사회질서를 해하는 행위 또는
                            타인의 명예를 손상시키거나 불이익을 주는 행위를 한
                            경우
                          </li>
                          <li>
                            - 기타 이 약관이나 관계법령에서 정한 사항 위반 등
                            회원 자격을 그대로 유지시키기 어려운 상당한 이유가
                            있는 경우
                          </li>
                        </ul>
                      </li>
                      <li>
                        ② 회사는 이용제한할 경우 그 사유, 일시 및 기간을 정하여
                        이용제한 5일전까지 서면, 전화, e-mail 등을 통하여
                        회원에게 통지합니다.
                      </li>
                    </ul>
                  </li>
                  <li>
                    <h4 class="agree_h2">제 24 조 (이용제한 해제)</h4>
                    <p class="agree_p">
                      회사는 이용제한기간중에 그 이용제한사유가 해소된 것이
                      확인된 경우 이용제한조치를 즉시 해제하며, 그 사실을
                      회원에게 통지합니다.
                    </p>
                  </li>
                  <li>
                    <h4 class="agree_h2">
                      제 25 조 (서비스 제공의 제한 및 중지)
                    </h4>
                    <ul class="agree_in">
                      <li>
                        ① 회사는 다음 각 호에 해당하는 경우 서비스의 이용을 전부
                        또는 일부를 제한하거나 중지할 수 있습니다.
                        <ul class="agree_in02">
                          <li>
                            - 시스템 보수 및 데이터 관리를 위하여 부득이한 경우
                          </li>
                          <li>
                            - 전기통신사업법에 규정된 기간통신사업자가
                            전기통신서비스를 중지한 경우
                          </li>
                          <li>
                            - 국가 비상사태, 천재지변이 발생하거나 발생할 우려가
                            있는 경우
                          </li>
                        </ul>
                      </li>
                      <li>
                        ② 제①항에 의한 서비스 중단의 경우 그 사유 등을
                        홈페이지에 게시하거나 회원에게 통지합니다. 다만 회사가
                        통제할 수 없는 사유로 인하여 사전통지가 불가능한 경우
                        그러하지 아니합니다.
                      </li>
                    </ul>
                  </li>
                  <li>
                    <h4 class="agree_h2">제 26 조 (해지)</h4>
                    <ul class="agree_in">
                      <li>
                        ① 회원이 이용계약을 해지하고자 하는 경우 신청서에 의거
                        전화, 팩스 또는 E-Mail 을 통하여 회사에 신청하여야
                        합니다.
                      </li>
                      <li>
                        ② E-Mail 을 통하여 회원탈퇴를 신청한 경우에는 본인을
                        확인할 수 있는 이름, 아이디(ID), 비밀번호, 연락처 및
                        해지사유를 통보하여야 하며, 이 경우 당사는
                        회원등록정보와 대조하여 본인 여부를 확인한 후 해지하여야
                        합니다.
                      </li>
                      <li>
                        ③ 이용계약의 해지시 회원은 최종 요금 납부 이후 이용한
                        서비스에 대한 이용요금을 모두 납입하여야 합니다.
                      </li>
                      <li>
                        ④ 회사는 회원이 제21조 및 기타 이 약관의 규정을
                        위반하고, 당사가 정한 소정의 기간 내에 이를 해소하지
                        아니하는 경우에 서비스 이용계약을 사전 통지나 동의 없이
                        해지할 수 있습니다.
                      </li>
                    </ul>
                  </li>
                </ul>
                <h3 class="agree_h1">제 6 장 기타</h3>
                <ul class="agree_list">
                  <li>
                    <h4 class="agree_h2">제 27 조 (양도금지)</h4>
                    <p class="agree_p">
                      회원이 서비스의 이용권한, 기타 이용계약상 지위를 타인에게
                      양도하거나 담보로 제공할 수 없습니다.
                    </p>
                  </li>
                  <li>
                    <h4 class="agree_h2">제 28 조 (손해배상)</h4>
                    <ul class="agree_in">
                      <li>
                        ① 회원이 제21조 및 기타 이 약관의 규정을 위반함으로
                        인하여 회사가 다른 회원 또는 제3자에 대하여 책임을
                        부담하게 되고 이로 인해 회사가 손해를 입게 되는 경우
                        회원은 회사에게 모든 손해를 배상하여야 합니다.
                      </li>
                      <li>
                        ② 회사는 서비스 제공과 관련하여 회원에게 어떠한 손해가
                        발생한 경우 고의 또는 중과실이 없는 한 이에 대하여
                        책임지지 않습니다.
                      </li>
                    </ul>
                  </li>
                  <li>
                    <h4 class="agree_h2">제 29 조 (면책사항)</h4>
                    <ul class="agree_in">
                      <li>
                        ① 회사는 회원이 게재한 정보, 자료 및 그에 대한 사실의
                        정확성, 신뢰성 등에 관하여는 어떠한 책임도지지 않으며,
                        서비스를 이용하여 게시 또는 전송한 자료, 자료의
                        취사선택, 기타 서비스 이용과 관련하여 회원에게 어떠한
                        손해 또는 불이익이 발생하더라도 이에 대한 모든 책임은
                        회원에게 있습니다.
                      </li>
                      <li>
                        ② 회사는 제21조 규정을 위반하여 회원간 또는 회원과
                        제3자간에 회사의 서비스를 매개로 하여 물품거래 등의
                        행위에 대하여 어떠한 책임도 지지 않습니다.
                      </li>
                      <li>
                        ③ 회원 아이디(ID)와 비밀번호/ 블록체인 계정주소와
                        블록체인 비밀번호의 관리 및 이용상의 부주의로 인하여
                        발생되는 손해 또는 제3자에 의한 부정사용 등에 대한
                        책임은 모두 회원에게 있습니다.
                      </li>
                      <li>
                        ④ 회사는 다음 각호의 경우에 대하여는 책임을 지지
                        아니합니다.<br />
                        <ul class="agree_in02">
                          <li>
                            - 천재지변 등 불가항력적인 사유로 서비스를 제공하지
                            못하는 경우
                          </li>
                          <li>
                            - 회원이 제공하는 자료의 오류로 인하여 발생한 손해
                          </li>
                          <li>
                            - 통신기기, 통신회선 또는 회사의 전산 시스템 장애에
                            의한 업무처리의 지연이나 불능일 경우
                          </li>
                          <li>
                            - 회원이 바이러스 침투, 불법S/W설치 등 관리소홀 및
                            부주의로 손해가 발생한 경우
                          </li>
                          <li>
                            - 기타 회사의 과실로 인하여 발생한 사고가 아닌 경우
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <h4 class="agree_h2">제 30 조 (분쟁해결 및 관할법원)</h4>
                    <ul class="agree_in">
                      <li>
                        ① 본 계약의 해석과 관련하여 이견이 있을 경우 및 본
                        계약에 제시되지 않은 사항이 있을 경우 관련법규가 있으면
                        그 관련법규를 따르고 관련법규가 없으면 신의성실의 원칙에
                        입각, 상호협의하여 결정합니다.
                      </li>
                      <li>
                        ② 본 계약과 관련한 분쟁의 해결에 대해서는 서울지방법원을
                        관할법원으로 합니다.
                      </li>
                    </ul>
                    <!--
											<p class="agree_p2">
												2018. 10. 18
											</p>
											-->
                  </li>
                  <li>
                    <h4 class="agree_h2">제 31 조 (면책조항)</h4>
                    <ul class="agree_in">
                      <li>
                        ①계약 작성자는 계약 수신자 정보(이름, 휴대폰 번호, 메일
                        주소 등)의 진위 여부를 확인한 후 계약을 발송해야하며,
                        잘못된 정보 입력으로 발생하는 문제에 대해 책임지지
                        않습니다.
                      </li>
                      <li>
                        ②글로싸인엔터프라이즈를 통해 이뤄지는 회원 및 이용자
                        간에 이뤄지는 전자계약 작성, 전송, 서명 등 진행과정과
                        내용 이행 등에서 발생하는 분쟁에 대해 책임지지 않습니다.
                      </li>
                    </ul>
                  </li>
                  <li>
                    <ul class="agree_in">
                      <li>공고일자 : 2022년 10월 5일</li>
                      <li>시행일자 : 2022년 10월 12일</li>
                    </ul>
                  </li>
                </ul>
              </v-col>
              <!--/시행중인 이용약관 보기-->
            </v-row>
          </div>
        </div>
        <div>
          <v-radio-group class="radioCon02" row>
            <v-radio
              label="동의합니다"
              value="2"
              v-on:click="acceptTermSelect('radio_trem_use2')"
            ></v-radio>
            <v-radio
              label="동의하지 않습니다"
              v-on:click="acceptTermSelect('radio_trem_use1')"
              value="1"
            ></v-radio>
          </v-radio-group>
        </div>
      </div>
      <div class="mt-4">
        <div class="dot_tt16 mb-2">
          (필수) 개인정보 수집 ·이용에 관한 안내
          <v-btn text class="posiA_right0 btn_txt" @click="personInfo"
            >개인정보 처리방침 전체 보기<span class="icon arr"></span
          ></v-btn>
        </div>
        <ul class="signU_rule_box02">
          <li>
            <div class="st_tt">수집 및 이용목적</div>
            <div class="st_txt">
              <h5 class="mt-2">회원관리</h5>
              <ul class="pattern_ul_terms12 mb-2">
                <li>
                  1. 회원제 서비스 이용 및 제한적 본인 확인제에 따른 본인확인
                </li>
                <li>2. 개인식별, 신용평가기관을 통한 실명확인</li>
                <li>3. 연령제한 서비스의 제공</li>
                <li>4. 부정이용방지와 비인가 사용방지</li>
                <li>5. 가입의사 확인</li>
                <li>6. 불만처리 등 민원처리</li>
                <li>7. 고지사항 전달</li>
              </ul>
            </div>
          </li>
          <li>
            <div class="st_tt">수집항목</div>
            <div class="st_txt">
              <ul class="pattern_ul_terms12 mb-2">
                <li>
                  아이디, 비밀번호, 이름, 연락처, 주소, 상세주소, 이메일, 블록체인 비밀번호
                </li>
              </ul>
            </div>
          </li>
          <li>
            <div class="st_tt">보유 및 이용기간</div>
            <div class="st_txt">
              <ul class="pattern_ul_terms12 mb-2">
                <li><strong>회원탈퇴 또는 개인정보 유효기간 도래 시까지 보관</strong></li>
                <li>
                <strong>
                  단, 관계 법령에 따라 고객님의 개인정보를 보존하여야 하는 경우,
                  회사는 해당 법령에서 정한 기간 동안 보관합니다.
                </strong>
                </li>
              </ul>
            </div>
          </li>
        </ul>
        <div>
          <div class="mt-2 txtst_info_red6">
            ※ 고객님께서는 (필수)개인정보 수집 및 이용에 대한 동의를 거부하실 수
            있으며, 동의 거부 시 회원 가입이 제한됩니다.
          </div>
          <v-radio-group class="radioCon02" row>
            <v-radio
              label="동의합니다"
              v-on:click="acceptTermSelect('radio_trem_paivacy_op12')"
              value="2"
            ></v-radio>
            <v-radio
              label="동의하지 않습니다"
              v-on:click="acceptTermSelect('radio_trem_paivacy_op11')"
              value="1"
            ></v-radio>
          </v-radio-group>
        </div>
      </div>
      <div>
        <div class="dot_tt16 mb-2">(선택) 개인정보 수집 ·이용에 관한 안내</div>
        <ul class="signU_rule_box02">
          <li>
            <div class="st_tt">수집 및 이용목적</div>
            <div class="st_txt">
              <ul class="pattern_ul_terms12 mb-2">
                <li>마케팅 및 광고 활용</li>
              </ul>
            </div>
          </li>
          <li>
            <div class="st_tt">수집항목</div>
            <div class="st_txt">
              <ul class="pattern_ul_terms12 mb-2">
                <li>이메일, 연락처</li>
              </ul>
            </div>
          </li>
          <li>
            <div class="st_tt">보유 및 이용기간</div>
            <div class="st_txt">
              <ul class="pattern_ul_terms12 mb-2">
                <li><strong>회원탈퇴 또는 개인정보 유효기간 도래 시까지 보관</strong></li>
                <li>
                <strong>
                  단, 관계 법령에 따라 고객님의 개인정보를 보존하여야 하는 경우,
                  회사는 해당 법령에서 정한 기간 동안 보관합니다.
                </strong>
                </li>
              </ul>
            </div>
          </li>
        </ul>
        <div>
          <div class="mt-2 txtst_info_gray6">
            ※ (선택)개인정보 수집 및 이용에 대한 동의를 거부하시더라도
            글로싸인엔터프라이즈 서비스 이용이 가능합니다.
          </div>
          <v-radio-group class="radioCon02" row>
            <v-radio
              label="동의합니다"
              value="2"
              v-on:click="acceptTermSelect('radio_trem_paivacy_op22')"
            ></v-radio>
            <v-radio
              label="동의하지 않습니다"
              value="1"
              v-on:click="acceptTermSelect('radio_trem_paivacy_op21')"
            ></v-radio>
          </v-radio-group>
        </div>
      </div>
    </v-card-text>
    <v-card-actions class="justify-center signup_btnCon">
      <v-btn
        outlined
        class="btn19_00 btnC_01 btn_bottom_W314"
        @click="accept_term"
        >약관동의 완료</v-btn
      >
      <!--다음으로 이동-->
    </v-card-actions>
    <s-confirm ref="confirm"></s-confirm>
    <s-loading ref="loading"></s-loading>
    <perInfoProtec ref="perInfoProtec"></perInfoProtec>
  </v-container>
</template>
<script>
import perInfoProtec from "@/components/perInfoProtec";

export default {
  name: "acceptTerm",
  component: {
    perInfoProtec
  },
  props: {
    parentData: {}
  },
  data() {
    return {
      accountform: {
        auth_key: "",
        email: "",
        radio_trem_paivacy_op1: false,
        radio_trem_paivacy_op2: false
      },
      radio_trem_use: "",
      radio_trem_paivacy_op1: "",
      radio_trem_paivacy_op2: ""
    };
  },
  created() {
    this.accountform = this.parentData;
    if (this.$store.state.user.username !== "") {
      this.$refs.confirm
        .open(
          "confirm",
          "회원가입",
          "로그인 사용자입니다. 로그아웃 후 이용하세요"
        )
        .then(() => {
          this.$router.push("/");
        });
    } else {
      this.mounted();
    }
  },
  methods: {
    mounted() {
      if (this.accountform.auth_key === undefined) {
        // console.log('not found auth_key')
        this.invalid_authkey();
      }
    },
    invalid_authkey() {
      this.$refs.confirm
        .open("confirm", "회원가입", "인증정보가 없습니다. 다시 시도해주세요.")
        .then(() => {
          this.$router.push({ name: "join" });
        });
    },
    acceptTermSelect(rdSelect) {
      if (rdSelect === "radio_trem_use2") {
        this.radio_trem_use = "2";
      } else if (rdSelect === "radio_trem_use1") {
        this.radio_trem_use = "1";
      } else if (rdSelect === "radio_trem_paivacy_op12") {
        this.radio_trem_paivacy_op1 = "2";
      } else if (rdSelect === "radio_trem_paivacy_op11") {
        this.radio_trem_paivacy_op1 = "1";
      } else if (rdSelect === "radio_trem_paivacy_op22") {
        this.radio_trem_paivacy_op2 = "2";
      } else if (rdSelect === "radio_trem_paivacy_op21") {
        this.radio_trem_paivacy_op2 = "1";
      }
    },
    accept_term() {
      // 약관 동의 관련 초기값 미선택으로 인해 변경 by노학배
      if (this.radio_trem_use === "1" || this.radio_trem_use === "") {
        this.accountform.radio_trem_use = false;
        this.$refs.confirm.open(
          "alert",
          "약관동의",
          "이용약관에 동의 하셔야 회원가입을 진행할 수 있습니다."
        );
        return 0;
      } else {
        this.accountform.radio_trem_use = true;
      }
      // 약관 동의 관련 초기값 미선택으로 인해 변경 by노학배
      if (
        this.radio_trem_paivacy_op1 === "1" ||
        this.radio_trem_paivacy_op1 === ""
      ) {
        this.accountform.radio_trem_paivacy_op1 = false;
        this.$refs.confirm.open(
          "alert",
          "약관동의",
          "개인정보 수집 및 이용 안내에 동의 하셔야 회원가입을 진행할 수 있습니다."
        );
        return 0;
      } else {
        this.accountform.radio_trem_paivacy_op1 = true;
      }
      if (this.radio_trem_paivacy_op2 === "2") {
        this.accountform.radio_trem_paivacy_op2 = true;
      } else if (this.radio_trem_paivacy_op2 === "") {
        this.accountform.radio_trem_paivacy_op2 = false;
        this.$refs.confirm.open(
          "alert",
          "약관동의",
          "개인정보 수집 및 이용 안내에 동의 여부를 선택해야 회원 가입을 진행할 수 있습니다."
        );
        return 0;
      } else {
        this.accountform.radio_trem_paivacy_op2 = false;
      }
      if (
        this.accountform.radio_trem_use &&
        this.accountform.radio_trem_paivacy_op1
      ) {
        this.$emit("termEvent", this.accountform);
      }
    },
    personInfo() {
      this.$refs.perInfoProtec.open();
    }
  }
};
</script>
<style scoped></style>
